var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBottomChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 452,
    height: 226,
    viewBox: "0 0 452 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8025_292)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2421 71.1288L151.425 198.448C171.511 216.132 198.221 226 226 226C253.779 226 280.489 216.132 300.575 198.448L438.758 71.1288C447.237 63.3149 452 52.7169 452 41.6663C452 30.6157 447.237 20.0177 438.758 12.2038C430.279 4.38985 418.779 0 406.788 0C394.798 0 383.298 4.38985 374.819 12.2038L236.636 139.551C233.811 142.154 229.98 143.616 225.985 143.616C221.99 143.616 218.159 142.154 215.333 139.551L77.181 12.2038C68.7022 4.38985 57.2024 0 45.2115 0C33.2207 0 21.7209 4.38985 13.2421 12.2038C4.76328 20.0177 0 30.6157 0 41.6663C-3.05176e-05 52.7169 4.76328 63.3149 13.2421 71.1288Z",
    fill: "#7FFAA1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8025_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 452,
    height: 226,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBottomChevron);
export default __webpack_public_path__ + "static/media/green-bottom-chevron.857dea2b6fcca3397f0a9ebbd53f21f6.svg";
export { ForwardRef as ReactComponent };